<template>
  <div class="product-item">
    <!-- Product Image Container -->
    <router-link
      :to="`${item.path}`"
      class="image-container"
      tag="a"
    >
      <div class="content-layer">
        <div class="product-tags">
          <div
            v-if="item.award_winner"
            class="special-tag"
          >
            <div class="tag-content">
              Award Winner
            </div>
          </div>
          <div
            v-if="lowStock(item.id)"
            class="low-stock-tag"
          >
            <div class="tag-content">
              Low Stock
            </div>
          </div>
          <div
            v-if="outOfStock(item.id)"
            class="out-of-stock-tag"
          >
            <div class="tag-content">
              Out of Stock
            </div>
          </div>
        </div>
        <div class="product-teaser-quick-view-container hidden-sm hidden-xs">
          <b-button
            class="quick-view"
            title="Quickview"
          >
            <span>
              View product
            </span>
          </b-button>
        </div>
      </div>
      <AImage
        :img="item.image"
        preset="wineproductteaser"
        contain
      />
    </router-link>

    <!-- Product Teaser -->
    <div class="description-container">
      <div
        v-if="item.brand && item.brand !== 'unknown'"
        class="product-brand"
      >
        {{ item.brand }}
      </div>

      <!-- Product Title -->
      <h3 class="product-name">
        <router-link
          :to="`${item.path}`"
          tag="a"
        >
          {{ item.title }}
        </router-link>
      </h3>

      <!-- Product Price -->
      <div class="product-price-container">
        <div class="price">
          <ecommerce-product-price
            :item="priceCalcItem"
            :showrrprice="false"
          />
        </div>
      </div>

      <!-- Product Description -->
      <div
        v-if="item.abstract"
        class="product-description"
      >
        <div v-html="item.abstract" />
      </div>

      <!-- Product Description Extra -->
      <div
        v-if="item.descriptionExtra"
        class="product-description-extra"
        v-html="item.descriptionExtra"
      />

      <!-- View Product Button -->
      <div class="product-teaser-actions">
        <router-link
          :to="`${item.path}`"
          tag="a"
          class="cart-btn btn"
          title="View Product"
        >
          View Product
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'wine-product-list-item-0001',
  filters: {
    deDash(string) {
      if (string) {
        return string.replace('_', ' ')
      }
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    productStock() {
      return this.$store.getters['productCatalog/getProductStock']
    },
    lowStockThreshold() {
      return this.$store.getters['productCatalog/getLowStockThreshold']
    },
    priceCalcItem: function() {
      return {
        ...this.item,
        ptype: this.item.ptype,
        taxonomy: this.item.discountGroup,
        type: this.item.node_type
      }
    }
  },
  methods: {
    lowStock(id) {
      const productExistsInStock = typeof this.productStock[id] !== 'undefined'

      if (!productExistsInStock) {
        return false
      }

      const productIsStockManaged = this.parseBoolean(this.productStock[id].manage_stock)
      const productHasStockAvailable = parseInt(this.productStock[id].stock) > 0
      const productStockMeetsLowStockThreshold = parseInt(this.productStock[id].stock) <= this.lowStockThreshold

      return (productStockMeetsLowStockThreshold && productHasStockAvailable && productIsStockManaged)
    },
    outOfStock(id) {
      const productExistsInStock = typeof this.productStock[id] !== 'undefined'

      if (!productExistsInStock) {
        return false
      }

      const productIsStockManaged = this.parseBoolean(this.productStock[id].manage_stock)
      const productStockIsEmpty = parseInt(this.productStock[id].stock) <= 0

      return (productIsStockManaged && productStockIsEmpty)
    },
    parseBoolean(v) {
      if (typeof v === 'string' && ['true', 'on', 'yes'].includes(v.toLowerCase())) {
        return true
      }
      else if (typeof v === 'string' && v !== '' && v !== '0') {
        return true
      }
      else if (typeof v === 'number' && !isNaN(parseInt(v)) && parseInt(v) !== 0) {
        return true
      }
      else if (typeof v === 'boolean') {
        return v
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@scss/custom.scss';

.product-item {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding-bottom: 1.5em;
  margin-bottom: 1.5em;
  /*border-bottom: 1px solid var(--main-border-color);*/

  &:not(:last-child) {
    border-bottom: 1px solid var(--main-border-color);
  }

  @include media-breakpoint-up(md) {
    padding-bottom: 2em;
    margin-bottom: 2em;
    flex-direction: row;
  }

  .image-container {
    @include media-breakpoint-down(md) {
      margin-bottom: 1.5em;
    }

    @include media-breakpoint-up(md) {
      margin-right: 1.5em;
    }
  }

  .description-container {

    @include media-breakpoint-up(md) {
      flex: 3;
    }

    .product-brand {
      font-size: 1em;
      font-weight: bold;
      margin-bottom: .25em;
    }

    h3.product-name {
      font-size: 2em;
      word-break:break-all;
      word-break: break-word;
      a {
        color: var(--main-text-heading-color);
      }
    }

    .product-price-container {
     ::v-deep .price {
        font-size: 1.5em;
        color: var(--main-product-price-text-color);
        margin: 1rem 0em;
      }

     ::v-deep label {
        margin: 0em;
        display: none;
      }
    }

    .product-description {
      ul {
        display: none;
      }
    }

    .product-description-extra {
      font-size: 1.3em;
      padding: 1em 0 2em 0;
      font-weight: bold;
    }

    .cart-btn {
      color: var(--main-link-color);
      border: 1px solid;
      border-color: var(--main-link-color);

    }

  }
}
.image-container {
  display: flex;
  transition: var(--main-transition);
  position: relative;
  overflow: hidden;
  flex: 1.5;
  .content-layer {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    overflow: hidden;
    .product-tags {
      position: absolute;
      top: .75em;
      left: .75em;
      z-index: 2;

      .out-of-stock-tag {
        background: var(--main-oos-badge-background-color);
        border-radius: 50%;
        width: 5em;
        height: 5em;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .9em;
        padding: 0.5em;

        .tag-content {
          font-size: .867em;
          color: var(--main-oos-badge-text-color);
          text-transform: capitalize;
        }
      }

      .special-tag {
        background: var(--main-award-badge-background-color);
        border-radius: 50%;
        width: 5em;
        height: 5em;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .9em;

        .tag-content {
          font-size: .867em;
          color: var(--main-award-badge-text-color);
          text-transform: capitalize;
        }
      }
    }

    @include hover-focus {
      .btn.quick-view {
        opacity: 1;
        transform: translate(0, 0em);
      }
    }

    .btn.quick-view {
      background-color:var(--main-link-color);
      border-color:var(--main-link-color);
      color:var(--main-text-overlay-color);
      opacity: 0;
      transition: transform .3s, opacity .3s;
      transform: translate(0, 100%);
      position: absolute;
      width: 100%;
      font-size: 1em;
      border-radius: 0px;
      margin: 0;
      left: 0;
      bottom: 0;
      z-index: 2;
    }
  }
  .a-image {
    padding-top: var(--main-product-image-aspect-ratio, 100%);
    background: var(--main-product-image-background);
    box-shadow: var(--main-product-image-box-shadow);
  }
}

.product-item {
  ::v-deep .image-container {
    .a-image {
      img {
        padding: 1.5em;
      }
    }
  }
}
</style>
